import HANDLE_PATHS from '@/lib/handle-paths.json';
import { redactBearerPaths } from '@/lib/bearer-paths';

// Another person's handle in a URL path: profile pages and feeds, feed mutes
// and blocked users, in every locale (#518). handle-paths.json is generated
// from the Rails route table (SentryPrivatePaths.handle_paths), and a spec
// fails when it drifts. `except` lists the pages that sit where a handle
// would, such as /app/people/invite.
const escape = (value) => value.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&');

// eslint-disable-next-line security/detect-non-literal-regexp -- built from the committed route list (escaped above), never user input
const HANDLE_PATH = new RegExp(
  `(${HANDLE_PATHS.map(({ prefix, except }) => {
    const guard = except.length
      ? `(?!(?:${except.map(escape).join('|')})(?:[/?#.\\s"]|$))`
      : '';
    return escape(prefix) + guard;
  }).join('|')})[^/?#\\s"]+`,
  'g',
);

// What Sentry and Google Analytics must never receive in a URL path: bearer
// credentials and friends' handles. Mirrors SentryPrivatePaths.redact on the
// server.
export function redactPrivatePaths(value) {
  return typeof value === 'string'
    ? redactBearerPaths(value).replace(HANDLE_PATH, '$1[redacted]')
    : value;
}

// Compares after redacting rather than calling HANDLE_PATH.test(): the
// pattern is global, so .test() would carry lastIndex between calls. A path
// that is already redacted reads as not private, so decide before stripping.
export function hasPrivatePath(value) {
  return typeof value === 'string' && redactPrivatePaths(value) !== value;
}
